import React from 'react';
import { useSelector } from 'react-redux';

import { selectOrganization } from 'entities/user/selectors';
import { PARTNER_STATUSES } from 'entities/partners/constants';
import { PartnerCompany } from 'entities/organization/model';
import { ClickableUrl } from 'utils/urls';

export const PartnershipLabel = () => {
  const organization = useSelector(selectOrganization);

  if (typeof organization === 'undefined' || organization.type !== 'Nonprofit') {
    return null;
  }

  const partnerCompanies = organization.get('partnerCompanies') as PartnerCompany[];

  if (typeof partnerCompanies === 'undefined' || partnerCompanies.length === 0) {
    return null;
  }

  const approvedAffiliationWithLogo = partnerCompanies.find(
    (partnerCompany) =>
      partnerCompany.status === PARTNER_STATUSES.accepted &&
      partnerCompany.partnershipLogo &&
      partnerCompany.partnershipWebsiteUrl
  );

  if (!approvedAffiliationWithLogo) {
    return null;
  }

  const { name, partnershipLogo, partnershipWebsiteUrl } = approvedAffiliationWithLogo;

  const label = 'In partnership with';

  return (
    <div style={{ flex: 1, textAlign: 'right', paddingRight: '24px' }}>
      {label}
      {partnershipWebsiteUrl ? (
        <ClickableUrl href={partnershipWebsiteUrl} target="_blank" rel="noreferrer">
          <img
            style={{ paddingLeft: '12px' }}
            height="24px"
            alt={`${name}-logo`}
            src={partnershipLogo}
          />
        </ClickableUrl>
      ) : null}
    </div>
  );
};
